export const FLAGS = {
  RELEASE_DELIVERIES_LOAD_ASSIGNMENTS: 'RELEASE_DELIVERIES_LOAD_ASSIGNMENTS',
};

export const FLAG_LOAD_ASSIGNMENTS = FLAGS.RELEASE_DELIVERIES_LOAD_ASSIGNMENTS;
